import { createSelector } from "reselect";
import _ from "underscore";

import DateConverter from "../../converters/date_converter";
import getPhotoSessionsForPhotoAreaById from "../photo_area_getters/get_photo_sessions_for_photo_area_by_id";
import getScanDatasetsForFloorByFirebaseId from "./get_scan_datasets_for_floor_by_firebase_id";
import ScanDataset from "../../../models/domain/scan_dataset";

// The photo-driven counterpart to getMostRecentScanDatasetForFloor: the floor's latest-dated
// capture that actually has photos, ignoring any more recent scan-only one.
const getMostRecentPhotoScanDatasetForFloor = createSelector([
  getScanDatasetsForFloorByFirebaseId,
  getPhotoSessionsForPhotoAreaById
], (scanDatasetsByFirebaseId, photoSessionsById): ScanDataset | null => {
  const photographedDays = new Set(
    _(photoSessionsById).values().map(session => DateConverter.dateToUTCDayStringOrEmpty(session.sessionDate))
  );

  const photographed = _(scanDatasetsByFirebaseId).values().filter((scanDataset: ScanDataset) => {
    const day = DateConverter.dateToUTCDayStringOrEmpty(scanDataset?.scanDate);
    return day.length > 0 && photographedDays.has(day);
  });

  if (!photographed.length) {
    return null;
  }

  return _.max(photographed, (scanDataset: ScanDataset) => new Date(scanDataset.scanDate).valueOf()) as ScanDataset;
});

export default getMostRecentPhotoScanDatasetForFloor;
